function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "x2");

function SvgIcnDoubleled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 163",
    d: "M11.54 10.63a.86.86 0 0 1-1.72 0v-3a.86.86 0 0 1 1.72 0v3m-5.95 1.19-1.54-2-.23-.29a.84.84 0 0 0-.6-.25.86.86 0 0 0-.61.25.88.88 0 0 0-.25.61 1 1 0 0 0 .25.61l1.54 2 .23.29a.855.855 0 0 0 1.46-.61 1 1 0 0 0-.25-.61M17 13l1.54-2 .23-.28a1 1 0 0 0 .25-.61.93.93 0 0 0-.25-.61.88.88 0 0 0-.61-.25.86.86 0 0 0-.61.25l-1.54 2-.23.28a1 1 0 0 0-.25.61.93.93 0 0 0 .25.61.88.88 0 0 0 .61.25A.86.86 0 0 0 17 13M5.73 27.71v-7.62a12.87 12.87 0 0 1 0-1.52v.23a6.44 6.44 0 0 1 .4-1.49 1.8 1.8 0 0 1-.08.21 5.64 5.64 0 0 1 .52-1l.17-.25c0-.05.14-.16 0 .06l.1-.12a4.59 4.59 0 0 1 .36-.41c.13-.12.27-.25.41-.36a.35.35 0 0 1 .11-.1s-.18.14 0 .05l.23-.17a5.87 5.87 0 0 1 1-.53l-.21.09a6 6 0 0 1 1.49-.41H10a6.36 6.36 0 0 1 1.51 0h-.23a5.77 5.77 0 0 1 1.49.41l-.2-.09a6 6 0 0 1 1 .52l.24.18c.05 0 .16.13 0-.05l.12.1.4.36c.13.13.25.27.37.41s.09.08.09.12-.14-.19 0-.06l.16.23a5.23 5.23 0 0 1 .53 1 1.8 1.8 0 0 0-.08-.21 6 6 0 0 1 .4 1.49v-.23a10.16 10.16 0 0 1 0 1.35v7.79l.86-.86H4.88a.87.87 0 0 0-.86.86.88.88 0 0 0 .86.86h11.6a.88.88 0 0 0 .86-.86v-8.17a6.8 6.8 0 0 0-1.18-4A6.666 6.666 0 0 0 4 19.34v8.37a.87.87 0 0 0 .86.86.88.88 0 0 0 .87-.86m3.61 4.65v-9.48a.86.86 0 1 0-1.72 0v9.48a.87.87 0 0 0 .86.86.88.88 0 0 0 .86-.86m1-10.32h2.52l-.86-.86v11.18a.87.87 0 0 0 .86.86.88.88 0 0 0 .86-.86V21.18a.87.87 0 0 0-.86-.86h-2.49a.87.87 0 0 0-.86.86.88.88 0 0 0 .86.86m7.55 4.81H3.46a.87.87 0 0 0-.86.86.88.88 0 0 0 .86.86h14.46a.86.86 0 0 0 0-1.72",
    style: {
      fill: "#5e5e5d"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(21.08 28.57)",
    style: {
      fontSize: 14,
      fontFamily: "Inter",
      fontWeight: 700,
      fill: "#5e5e5d"
    }
  }, _ref)));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDoubleled);
export default __webpack_public_path__ + "static/media/icn-doubleled.05a3ce11aca5bbe034d074ffb0168688.svg";
export { ForwardRef as ReactComponent };